import { Spinner } from '@change/ds-core-ui/Spinner';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { withPrefetchedData } from '#src/shared/prefetch';

import { MovementPageContextProvider, prefetchPageContext } from '#src/app/pages/movement/pageContext';
import type { MovementPagePrefetchedDataProps } from '#src/app/pages/movement/pageContext';
import { isLoaded } from '#src/app/shared/utils/async';

import { Layout } from '../layout';

import { MovementErrorHandler } from './ErrorHandler';

export const Movement = withPrefetchedData(
	function Movement({ prefetchedData }: MovementPagePrefetchedDataProps) {
		const { movementId } = useKnownAvailableParams<{ movementId: string }>();

		return (
			<MovementPageContextProvider
				slug={movementId}
				prefetchedData={prefetchedData}
				errorHandler={MovementErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</MovementPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// oxlint-disable-next-line typescript/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.movementId!, context),
		pageTitle: ({ prefetchedData }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return undefined;
			}
			return `${prefetchedData.pageData.pageData.movement.objective} · Movement`;
		},
		pageMetadata: ({ prefetchedData }) => {
			if (!isLoaded(prefetchedData.pageData)) {
				return {};
			}
			return {
				description: prefetchedData.pageData.pageData.movement.descriptionStripped,
			};
		},
	},
);
